export default __webpack_public_path__ + "static/media/sign-up-image.41536f8d.png";